<div class="statsPopup" *ngIf="stats && stats.player && stats.team">
  <p>
    <span class="team">{{ stats.team.code }}</span>
    <strong>{{ stats.player.name }} {{ stats.points }} {{ 'PT Shot' | translate }}:</strong>
    <span class="result" [class.missed]="stats.fail">{{ stats.fail ? ('Missed' | translate) : ('Made' | translate) }}</span>
    <span *ngIf="!stats.fail && stats.assist" class="assist">{{ 'Assist' | translate }}: {{ stats.assist.name }}</span>
  </p>
  <p>
    <span class="time" [innerHTML]="(stats.time | matchTime) + ' (' + stats.quarter + ')'"></span>
    <span class="score">
      <span [class.changed]="!stats.fail && stats.team.isHome">{{ stats.result.home }}</span>
      {{'·'}}
      <span [class.changed]="!stats.fail && !stats.team.isHome">{{ stats.result.visitor }}</span>
    </span>
  </p>
</div>
